module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-01.550dedf9.jpg";